import { createSelector } from "reselect";

const selectFeedBack = (state) => state.feedback;

export const feedbackLoading = createSelector(
  [selectFeedBack],
  (feedback) => feedback.isLoading
);

export const feedbackPosting = createSelector(
  [selectFeedBack],
  (feedback) => feedback.isPosting
);

export const feedbackList = createSelector(
  [selectFeedBack],
  (feedback) => feedback.feedbacks
);

export const currentFeedback = createSelector(
  [selectFeedBack],
  (feedback) => feedback.currentFeedback
);
